import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import { createIndexedDBStorageManager } from './indexedDBStorageManager';
import {
  REACT_QUERY_CACHE_KEY,
  REACT_QUERY_DB_NAME,
  REACT_QUERY_DB_VERSION,
  REACT_QUERY_FALLBACK_STORAGE_KEY,
  REACT_QUERY_STORE_NAME,
} from './reactQueryIndexedDBPersister.constants';

const reactQueryStorage = createIndexedDBStorageManager({
  dbName: REACT_QUERY_DB_NAME,
  dbVersion: REACT_QUERY_DB_VERSION,
  storeName: REACT_QUERY_STORE_NAME,
  fallbackStorageKey: REACT_QUERY_FALLBACK_STORAGE_KEY,
  logNamespace: 'React Query cache storage',
});

export const createReactQueryIndexedDBPersister = (): Persister => ({
  persistClient: (client: PersistedClient) => reactQueryStorage.set(REACT_QUERY_CACHE_KEY, client),
  restoreClient: async () => {
    const result = await reactQueryStorage.getResult<PersistedClient>(REACT_QUERY_CACHE_KEY);
    return result.status === 'found' ? result.value : undefined;
  },
  removeClient: () => reactQueryStorage.remove(REACT_QUERY_CACHE_KEY),
});
